import { render, staticRenderFns } from "./MarketingOfficer.vue?vue&type=template&id=2c5a7e6a&scoped=true&"
import script from "./MarketingOfficer.vue?vue&type=script&lang=js&"
export * from "./MarketingOfficer.vue?vue&type=script&lang=js&"
import style0 from "./MarketingOfficer.vue?vue&type=style&index=0&id=2c5a7e6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a7e6a",
  null
  
)

export default component.exports